import React, { useCallback, useEffect, useState } from 'react';
import BillJobComparisonTable from '../components/BillJobComparisonTable';
import MonthYearPickerState from 'components/DatePicker/MonthYearPickerState';
import BasicSelectInput from 'components/SelectInput/BasicSelectInput';
import { getWeekendDate } from 'features/billJob/billJob/billJob.reducer';
import { RootState } from 'app/store';
import { useAppDispatch, useAppSelector } from 'helpers/redux';
import Button from 'components/Button/Button';
import GDevComparisonTable from '../components/GDevComparisonTable';

const BillJobComparison = () => {
    const gridRef = React.useRef<any>();
    const gdevGridRef = React.useRef<any>();

    const dispatch = useAppDispatch();

    const [monthSelected, setMonthSelected] = useState<Date>(new Date());
    const [weekendSelected, setWeekendSelected] = useState<string>('all');

    const weekendDateOptions = useAppSelector(
        (state: RootState) => state.billJob.weekendDateOptions ?? [],
    );

    useEffect(() => {
        if (monthSelected !== undefined) {
            dispatch(
                getWeekendDate({
                    month: monthSelected.getMonth() + 1,
                    year: monthSelected.getFullYear(),
                }),
            );
        }
    }, [monthSelected]);

    useEffect(() => {
        if (gridRef.current && gridRef.current.api !== undefined) {
            gridRef.current.api.setFilterModel({
                monthYearFilter: {
                    filterType: 'text',
                    type: 'contains',
                    filter: monthSelected.toISOString(),
                },
                weekendDateFilter: {
                    filterType: 'text',
                    type: 'contains',
                    filter: weekendSelected,
                },
            });
        }
    }, [gridRef.current]);

    useEffect(() => {
        if (gdevGridRef.current && gdevGridRef.current.api !== undefined) {
            gdevGridRef.current.api.setFilterModel({
                monthYearFilter: {
                    filterType: 'text',
                    type: 'contains',
                    filter: monthSelected.toISOString(),
                },
                weekendDateFilter: {
                    filterType: 'text',
                    type: 'contains',
                    filter: weekendSelected,
                },
            });
        }
    }, [gdevGridRef.current]);

    const onSearchClicked = () => {
        refreshCache(undefined);
        gridRef.current.api.setFilterModel({
            monthYearFilter: {
                filterType: 'text',
                type: 'contains',
                filter: monthSelected.toISOString(),
            },
            weekendDateFilter: {
                filterType: 'text',
                type: 'contains',
                filter: weekendSelected,
            },
        });
       gdevGridRef.current.api.setFilterModel({
            monthYearFilter: {
                filterType: 'text',
                type: 'contains',
                filter: monthSelected.toISOString(),
            },
            weekendDateFilter: {
                filterType: 'text',
                type: 'contains',
                filter: weekendSelected,
            },
        });
    };

    const refreshCache = useCallback((route: any) => {
        const purge = !!document?.querySelector('#purge' as any)?.checked;
        gridRef.current.api.refreshServerSide({ route: route, purge: purge });
        gdevGridRef.current.api.refreshServerSide({ route: route, purge: purge });
    }, []);

    return (
        <div>
            <div className="p-2 md:p-10 bg-white dark:border-gray-700 dark:bg-gray-800 rounded-2xl">
                {/* <div className="flex justify-items-center">
                    <h1 className="text-lg leading-10 grow font-medium truncate mr-5 dark:text-gray-300">
                        Bill Job Comparison
                    </h1>
                </div> */}
                <div className="mt-3">
                    <div>
                        <div className={'flex'}>
                            <div className="w-1/4 mr-1">
                                <MonthYearPickerState
                                    name="monthFilter"
                                    label="Month / Year"
                                    placeholderText="Select month & year"
                                    selected={monthSelected}
                                    onChange={(date) =>
                                        setMonthSelected(date ?? new Date())
                                    }
                                />
                            </div>
                            <div className="w-1/4 mx-1">
                                <BasicSelectInput
                                    label="Week Ending"
                                    options={weekendDateOptions}
                                    name={'weekEndingFilter'}
                                    onChange={(e) =>
                                        setWeekendSelected(e.target.value)
                                    }
                                />
                            </div>
                            <div className="flex items-center ml-1">
                                <div className="mt-5">
                                    <Button
                                        color="success"
                                        type="button"
                                        title="Search"
                                        onClick={onSearchClicked}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-3">
                    <h1 className="text-lg leading-10 grow font-medium truncate mr-5 dark:text-gray-300">
                        Report Billing Comparison
                    </h1>
                    <BillJobComparisonTable
                        gridRef={gridRef}
                        monthSelected={monthSelected}
                        weekendSelected={weekendSelected}
                    />
                </div>
                <div className="mt-3">
                    <h1 className="text-lg leading-10 grow font-medium truncate mr-5 dark:text-gray-300">
                        GDEV Comparison
                    </h1>
                    <GDevComparisonTable
                        gridRef={gdevGridRef}
                        monthSelected={monthSelected}
                        weekendSelected={weekendSelected}
                    />
                </div>
            </div>
        </div>
    );
};

export default BillJobComparison;
